import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Home from "./pages/Dashboard/Home";
import Support from "./pages/Dashboard/Support";
import Custompc from "./pages/Custompc";
import PrebuildPC from "./pages/Prebuildpc/Prebuildpc";
import PCReveal from "./pages/test/PCReveal";
import "./App.css";

function AppRoutes() {
  const location = useLocation();

  // Pages where you don't want the Header
  const hideHeader = ["/register"]; // removed "/"

  return (
    <>
      {!hideHeader.includes(location.pathname) && <Header />}

      <Routes>
        {/* Public Routes */}
        {/* <Route path="/" element={<Home />} /> */}
        <Route path="/" element={<Home />} />
        <Route path="/custom" element={<Custompc />} />
        <Route path="/prebuilt" element={<PrebuildPC />} />
        <Route path="/support" element={<Support />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}
